//컬럼 정의
export const _columns = [
  {
    field: "psDate",
    headerName: "날짜",
    width: 130,
  },
  {
    field: "method",
    headerName: "사용/공급",
    width: 130,
  },
  {
    field: "engId",
    headerName: "에너지종류",
    width: 130,
  },
  
  {
    field: "engUnit",
    headerName: "단위",
    width: 130,
  },
  {
    field: "complexInloName",
    headerName: "산업단지명",
    width: 130,
  },
  {
    field: "companyInloName",
    headerName: "회사명",
    width: 130, 
  }, 
  {
    field: "plantInloName",
    headerName: "사업장명",
    width: 130,
  },
  {
    field: "sumAmt",
    headerName: "합계",
    width: 120,
    valueFormatter: (params) => {
      return new Intl.NumberFormat("ko-KR").format(params.value);
    },
  },
];


export const managerColumns = (columns) => {
  return columns.map((column) => ({
    ...column,
    headerClassName: "DataGridHeader",
  }));
};

export const columns2_3 = managerColumns(_columns);


export const nodeDataArray_sihwa = [ 
  { key: 1, inloName: "조합공용", inloNo:200201, loc: "0 100" ,category: "base", sourceInlono:0}, 
  { key: 2, inloName: "월성금속", inloNo:11109, loc: "200 100" ,category: "base" ,sourceInlono:200201}, 
  { key: 3, inloName: "세원테크", inloNo:11108, loc: "400 100"  ,category: "base",sourceInlono:11105},
  { key: 4, inloName: "대양프라텍#2", inloNo:11107, loc: "600 100"  ,category: "base",sourceInlono:200201},
  { key: 5, inloName: "대양프라텍#1", inloNo:11106, loc: "800 100"  ,category: "base",sourceInlono:200201},
  { key: 6, inloName: "케이엠프라임", inloNo:200131, loc: "800 300"  ,category: "base",sourceInlono:200201},
  { key: 7, inloName: "남도세정", inloNo:200143, loc: "600 300"  ,category: "base",sourceInlono:200201},
  { key: 8, inloName: "대양프라텍#3", inloNo:11105, loc: "400 300"  ,category: "base" ,sourceInlono:200201},
  { key: 9, inloName: "디에스금속", inloNo:200130, loc: "200 300"  ,category: "base",sourceInlono:200201},
  { key: 10, inloName: "시화도금단지", inloNo:11101, loc: "0 300"  ,category: "base",sourceInlono:11108},
];

export const linkDataArray_sihwa = [
  { from: 1, to: 2, fromSpot: "Right", toSpot: "Left" , color : "#aaa",  StrtInloNo:200201, endInloNo:11109},
  { from: 2, to: 3, fromSpot: "Right", toSpot: "Left" , color : "#aaa" , StrtInloNo:11109, endInloNo:11108},
  { from: 3, to: 4, fromSpot: "Right", toSpot: "Left" , color : "#aaa" , StrtInloNo:11108, endInloNo:11107},
  { from: 4, to: 5, fromSpot: "Right", toSpot: "Left" , color : "#aaa", StrtInloNo:11107, endInloNo:11106},
  { from: 5, to: 6, fromSpot: "None", toSpot: "Top" ,   color : "#aaa", StrtInloNo:11106, endInloNo:200131},
  { from: 6, to: 7, fromSpot: "Left", toSpot: "Right" , color : "#aaa" , StrtInloNo:200131, endInloNo:200143},
  { from: 7, to: 8, fromSpot: "Left", toSpot: "Right" , color : "#aaa", StrtInloNo:200143, endInloNo:11105},
  { from: 8, to: 9, fromSpot: "Left", toSpot: "Right" , color : "#aaa", StrtInloNo:11105, endInloNo:200130},
  { from: 9, to: 10, fromSpot: "Left", toSpot: "Right" , color : "#aaa",StrtInloNo:200130, endInloNo:11101},
];


export const nodeDataArray_inchon_steam = [ 
  { key: 1, inloName: "공용보일러1", inloNo:1, loc: "0 0" ,category: "base", }, 
  { key: 2, inloName: "공용보일러2", inloNo:2, loc: "0 50" ,category: "base", }, 
  { key: 3, inloName: "공용보일러3", inloNo:3, loc: "0 100" ,category: "base", }, 
  { key: 4, inloName: "공용보일러4", inloNo:4, loc: "0 150" ,category: "base", }, 
  { key: 5, inloName: "엘림테크", inloNo:200207, loc: "200 75" ,category: "base", }, 
  { key: 6, inloName: "인성산업", inloNo:211000, loc: "400 75" ,category: "base" }, 
  { key: 7, inloName: "남동금속", inloNo:13201, loc: "600 75"  ,category: "base"},
  { key: 8, inloName: "제일산업", inloNo:13228, loc: "800 75"  ,category: "base"},
  { key: 9, inloName: "영준금속", inloNo:211001, loc: "1000 75"  ,category: "base"},
  { key: 10, inloName: "와이제이테크", inloNo:200151, loc: "1200 75"  ,category: "base"},
  { key: 11, inloName: "성진산업", inloNo:200159, loc: "1400 75"  ,category: "base"},
  { key: 12, inloName: "광성금속", inloNo:200157, loc: "1600 75"  ,category: "base"},
  { key: 13, inloName: "씨와이테크", inloNo:200161, loc: "1600 300"  ,category: "base"},
  { key: 14, inloName: "태성", inloNo:211002, loc: "1400 300"  ,category: "base"},
  { key: 15, inloName: "세광하이테크", inloNo:211003, loc: "1200 300"  ,category: "base"},
  { key: 16, inloName: "화성금속", inloNo:200165, loc: "1000 300"  ,category: "base" },
  { key: 17, inloName: "쌍용", inloNo:200167, loc: "800 300"  ,category: "base"},
  { key: 18, inloName: "경중", inloNo:200169, loc: "600 300"  ,category: "base"},
  { key: 19, inloName: "케이앤피플래닝", inloNo:211004, loc: "400 300"  ,category: "base"},
  { key: 20, inloName: "큐빅코리아", inloNo:200171, loc: "200 300"  ,category: "base"},
  { key: 21, inloName: "쥬얼테크", inloNo:13207, loc: "0 300"  ,category: "base"},
];

export const linkDataArray_inchon_steam = [
  { from: 1, to: 5, fromSpot: "Right", toSpot: "Left" , color : "#aaa",  StrtInloNo:1, endInloNo:200207},
  { from: 2, to: 5, fromSpot: "Right", toSpot: "Left" , color : "#aaa",  StrtInloNo:2, endInloNo:200207},
  { from: 3, to: 5, fromSpot: "Right", toSpot: "Left" , color : "#aaa",  StrtInloNo:3, endInloNo:200207},
  { from: 4, to: 5, fromSpot: "Right", toSpot: "Left" , color : "#aaa",  StrtInloNo:4, endInloNo:200207},  
  { from: 5, to: 6, fromSpot: "Right", toSpot: "Left" , color : "#aaa",  StrtInloNo:200207, endInloNo:211000},
  { from: 6, to: 7, fromSpot: "Right", toSpot: "Left" , color : "#aaa" , StrtInloNo:211000, endInloNo:13201},
  { from: 7, to: 8, fromSpot: "Right", toSpot: "Left" , color : "#aaa" , StrtInloNo:13201, endInloNo:13228},
  { from: 8, to: 9, fromSpot: "Right", toSpot: "Left" , color : "#aaa", StrtInloNo:13228, endInloNo:211001},
  { from: 9, to: 10, fromSpot: "Right", toSpot: "Left" , color : "#aaa", StrtInloNo:211001, endInloNo:200151},
  { from: 10, to: 11, fromSpot: "Right", toSpot: "Left" , color : "#aaa", StrtInloNo:200151, endInloNo:200159},
  { from: 11, to: 12, fromSpot: "Right", toSpot: "Left" , color : "#aaa", StrtInloNo:200159, endInloNo:200157},
  { from: 12, to: 13, fromSpot: "None", toSpot: "Top" , color : "#aaa", StrtInloNo:200157, endInloNo:200161},
  { from: 13, to: 14, fromSpot: "Left", toSpot: "Right" , color : "#aaa" , StrtInloNo:200161, endInloNo:211002},
  { from: 14, to: 15, fromSpot: "Left", toSpot: "Right" , color : "#aaa" , StrtInloNo:211002, endInloNo:211003},
  { from: 15, to: 16, fromSpot: "Left", toSpot: "Right" , color : "#aaa" , StrtInloNo:211003, endInloNo:200165},
  { from: 16, to: 17, fromSpot: "Left", toSpot: "Right" , color : "#aaa" , StrtInloNo:200165, endInloNo:200167},
  { from: 17, to: 18, fromSpot: "Left", toSpot: "Right" , color : "#aaa" , StrtInloNo:200167, endInloNo:200169},
  { from: 18, to: 19, fromSpot: "Left", toSpot: "Right" , color : "#aaa" , StrtInloNo:200169, endInloNo:211004},
  { from: 19, to: 20, fromSpot: "Left", toSpot: "Right" , color : "#aaa" , StrtInloNo:211004, endInloNo:200171},
  { from: 20, to: 21, fromSpot: "Left", toSpot: "Right" , color : "#aaa" , StrtInloNo:200171, endInloNo:13207},

];


export const nodeDataArray_inchon_air = [ 
  { key: 1, inloName: "공용컴프레셔1", inloNo:1, loc: "0 50" ,category: "base", },   
  { key: 2, inloName: "공용컴프레셔2", inloNo:2, loc: "0 100" ,category: "base", },   
  { key: 3, inloName: "공용컴프레셔3", inloNo:3, loc: "0 150" ,category: "base", },   
  { key: 5, inloName: "엘림테크", inloNo:200207, loc: "200 100" ,category: "base", }, 
  { key: 6, inloName: "인성산업", inloNo:211000, loc: "400 100" ,category: "base",sourceInlono:200207 }, 
  { key: 7, inloName: "남동금속", inloNo:13201, loc: "600 100"  ,category: "base",sourceInlono:200207},
  { key: 8, inloName: "제일산업", inloNo:13228, loc: "800 100"  ,category: "base",sourceInlono:200207},
  { key: 9, inloName: "영준금속", inloNo:211001, loc: "1000 100"  ,category: "base",sourceInlono:200207},
  { key: 10, inloName: "와이제이테크", inloNo:200151, loc: "1200 100"  ,category: "base",sourceInlono:200207},
  { key: 11, inloName: "성진산업", inloNo:200159, loc: "1400 100"  ,category: "base",sourceInlono:200207},
  { key: 12, inloName: "광성금속", inloNo:200157, loc: "1600 100"  ,category: "base",sourceInlono:200207},
  { key: 13, inloName: "씨와이테크", inloNo:200161, loc: "1600 300"  ,category: "base",sourceInlono:200207},
  { key: 14, inloName: "태성", inloNo:211002, loc: "1400 300"  ,category: "base",sourceInlono:200207},
  { key: 15, inloName: "세광하이테크", inloNo:211003, loc: "1200 300"  ,category: "base",sourceInlono:200207},
  { key: 16, inloName: "화성금속", inloNo:200165, loc: "1000 300"  ,category: "base" ,sourceInlono:200207},
  { key: 17, inloName: "쌍용", inloNo:200167, loc: "800 300"  ,category: "base",sourceInlono:200207},
  { key: 18, inloName: "경중", inloNo:200169, loc: "600 300"  ,category: "base",sourceInlono:200207},
  { key: 19, inloName: "케이앤피플래닝", inloNo:211004, loc: "400 300"  ,category: "base",sourceInlono:200207},
  { key: 20, inloName: "큐빅코리아", inloNo:200171, loc: "200 300"  ,category: "base",sourceInlono:200207},
  { key: 21, inloName: "쥬얼테크", inloNo:13207, loc: "0 300"  ,category: "base",sourceInlono:200207},
];

export const linkDataArray_inchon_air = [
  { from: 1, to: 5, fromSpot: "Right", toSpot: "Left" , color : "#aaa",  StrtInloNo:1, endInloNo:200207},
  { from: 2, to: 5, fromSpot: "Right", toSpot: "Left" , color : "#aaa",  StrtInloNo:2, endInloNo:200207},
  { from: 3, to: 5, fromSpot: "Right", toSpot: "Left" , color : "#aaa",  StrtInloNo:3, endInloNo:200207},  
  { from: 5, to: 6, fromSpot: "Right", toSpot: "Left" , color : "#aaa",  StrtInloNo:200207, endInloNo:211000},
  { from: 6, to: 7, fromSpot: "Right", toSpot: "Left" , color : "#aaa" , StrtInloNo:211000, endInloNo:13201},
  { from: 7, to: 8, fromSpot: "Right", toSpot: "Left" , color : "#aaa" , StrtInloNo:13201, endInloNo:13228},
  { from: 8, to: 9, fromSpot: "Right", toSpot: "Left" , color : "#aaa", StrtInloNo:13228, endInloNo:211001},
  { from: 9, to: 10, fromSpot: "Right", toSpot: "Left" , color : "#aaa", StrtInloNo:211001, endInloNo:200151},
  { from: 10, to: 11, fromSpot: "Right", toSpot: "Left" , color : "#aaa", StrtInloNo:200151, endInloNo:200159},
  { from: 11, to: 12, fromSpot: "Right", toSpot: "Left" , color : "#aaa", StrtInloNo:200159, endInloNo:200157},
  { from: 12, to: 13, fromSpot: "None", toSpot: "Top" , color : "#aaa", StrtInloNo:200157, endInloNo:200161},
  { from: 13, to: 14, fromSpot: "Left", toSpot: "Right" , color : "#aaa" , StrtInloNo:200161, endInloNo:211002},
  { from: 14, to: 15, fromSpot: "Left", toSpot: "Right" , color : "#aaa" , StrtInloNo:211002, endInloNo:211003},
  { from: 15, to: 16, fromSpot: "Left", toSpot: "Right" , color : "#aaa" , StrtInloNo:211003, endInloNo:200165},
  { from: 16, to: 17, fromSpot: "Left", toSpot: "Right" , color : "#aaa" , StrtInloNo:200165, endInloNo:200167},
  { from: 17, to: 18, fromSpot: "Left", toSpot: "Right" , color : "#aaa" , StrtInloNo:200167, endInloNo:200169},
  { from: 18, to: 19, fromSpot: "Left", toSpot: "Right" , color : "#aaa" , StrtInloNo:200169, endInloNo:211004},
  { from: 19, to: 20, fromSpot: "Left", toSpot: "Right" , color : "#aaa" , StrtInloNo:211004, endInloNo:200171},
  { from: 20, to: 21, fromSpot: "Left", toSpot: "Right" , color : "#aaa" , StrtInloNo:200171, endInloNo:13207},

];

export const nodeDataArray_ansan_steam = [ 
  { key: 1, inloName: "대일개발", inloNo:210000, loc: "0 100" ,category: "base", }, 
  { key: 2, inloName: "GS E&R", inloNo:200208, loc: "200 100" ,category: "base" }, 
  { key: 3, inloName: "태림포장", inloNo:200177, loc: "400 100"  ,category: "base",sourceInlono:210000},
  { key: 4, inloName: "대창", inloNo:200179, loc: "600 100"  ,category: "base",sourceInlono:200208},
  
];

export const linkDataArray_ansan_steam = [
  { from: 1, to: 2, fromSpot: "Right", toSpot: "Left" , color : "#aaa",  StrtInloNo:210000, endInloNo:200208},
  { from: 2, to: 3, fromSpot: "Right", toSpot: "Left" , color : "#aaa" , StrtInloNo:200208, endInloNo:200177},
  { from: 3, to: 4, fromSpot: "Right", toSpot: "Left" , color : "#aaa" , StrtInloNo:200177, endInloNo:200179},  
];
